import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import {
  brand,
  brandFailed,
  brandSuccess,
  findModelById,
  findModelByIdFailed,
  findModelByIdSuccess,
  findProductIdBy,
  findProductIdByFailed,
  findProductIdBySuccess,
  findWheelers,
  findWheelersFailed,
  findWheelersSuccess,
} from "./slice";

//--------------------GetAllBrands-------------------------

function* brandSaga(action: ReturnType<typeof brand>): any {
  try {
    const response = yield call(request.get,endpoints.getAllBrands);
    yield put(brandSuccess(response.data));
  } catch (error: any) {
    yield put(brandFailed(error));
  }
}

function* findWheelerSaga({ payload }: ReturnType<typeof findWheelers>): any {
  try {
    const { limit, page, vehicleType } = payload as any;
    const response = yield call(
      request.get,
      `${endpoints.getFindWheeler}?limit=${limit}&page=${page}&vehicleType=${vehicleType}`
    );
    yield put(findWheelersSuccess(response.data));
  } catch (error: any) {
    yield put(findWheelersFailed(error));
  }
}

///

function* findProductIdBySaga({
  payload,
}: ReturnType<typeof findProductIdBy>): any {
  try {
    const { id } = payload as any;
    const response = yield call(
      request.get,
      `${endpoints.findIdByProduct}/${id}`
    );
    yield put(findProductIdBySuccess(response.data));
  } catch (error: any) {
    yield put(findProductIdByFailed(error));
  }
}

///

function* findModelByIdSaga({
  payload,
}: ReturnType<typeof findModelById>): any {
  try {
    const { id } = payload as any;
    const response = yield call(
      request.get,
      `${endpoints.findModelById}/${id}`
    );
    
    yield put(findModelByIdSuccess(response.data));
  } catch (error: any) {
    yield put(findModelByIdFailed(error));
  }
}

function* brandSagas() {
  yield all([takeLatest(brand, brandSaga)]);
  yield all([takeLatest(findWheelers, findWheelerSaga)]);
  yield all([takeLatest(findProductIdBy, findProductIdBySaga), takeLatest(findModelById,findModelByIdSaga)]);
}

export { brandSagas };
